export default __webpack_public_path__ + "static/media/calendar.2fdd4571.svg";